/* eslint-disable no-constant-condition */
import Vue from "vue";
import router from "@/router";
import om, { retry } from "../api";
import cloneDeep from "lodash/cloneDeep";
import * as END_POINTS from "../config/constants/end-points";
import * as ACTIONS from "../config/constants/action-types";
import * as MUTATIONS from "../config/constants/mutation-types";
import ASO, { withTsecAuth } from "../api/aso";
import { agregarACola } from "../utils/promise-queue";
import {
  caminosBiometria,
  setearCaminosBiometria
} from "../config/constants/caminosBiometria";
import {
  CLIENTE_NO_CENSADO,
  ERROR_CONFIRMACION_RENAPER,
  ERROR_TECNICO,
  INDIVIDUO_NEGATIVO,
  ERROR_CONEXION,
  ERROR_REGISTRAR_DOMICILIO,
  ERROR_SERVICIO_VERIDAS,
  ERROR_REINTENTOS_BIOMETRIA,
  RECHAZADO,
  YA_CONTRATO,
  ERROR_SOLICITUD
} from "@/config/constants/step-constants";
import {
  checkAndAddNoNumber,
  mergeArrays,
  identificarErrorFotoDNI
} from "@/utils";
import get from "lodash/get";
import deepmerge from "deepmerge";
import config from "@/config/brands/index";
import caminos from "../config/constants/caminos";
import { circuitos, PCG7 } from "../config/constants/index";
import {
  guardarHandleOkStatus,
  processHandleErrorStatus,
  processHandleOkStatus,
  setModelDomicilioOption,
  setRehacerOption
} from "../utils/domicilios";
import { getParamMensajeContratacion } from "../config/constants/errores";
import { getParameterByName } from "../utils";
import { ERROR_CODES_CONTINUA_SUCURSAL } from "@/config/constants/errores";

const aplicarNormalizacion = (respuesta, domicilio) => {
  /**
   * Helper para normalización de domicilios
   */
  let localidad = domicilio.localidad;
  let domicilioNormalizado = deepmerge({}, domicilio);
  domicilioNormalizado.searchEncontesa = false;

  // Es válido?
  if (respuesta.validMerlin) {
    domicilioNormalizado = Object.assign(
      {},
      domicilioNormalizado,
      respuesta.domicilio
    );
    domicilioNormalizado.valido = true;
    domicilioNormalizado.provincia = respuesta.domicilio.codProvincia;
    /** 2021-07-06: Merlin no normaliza las ENIES vienen como ? */
    domicilioNormalizado.calle = get(domicilioNormalizado, "calle", "").replace(
      /[?=]/g,
      "N"
    );
  } else {
    domicilioNormalizado.valido = false;
    // Permitimos la búsqueda por encotesa?
    // Si viene el flag reintentar, le pedimos al usuario
    // que modifique los datos e intente de nuevo
    //
    // Se marca como deprecado por errores de contratación
    // @deprecated 2021-07-12
    // domicilioNormalizado.searchEncontesa = !respuesta.dudaMerlin && !respuesta.reintentar;
    // Siempre marcamos como false para NO permitir ir por encotesa
    domicilioNormalizado.searchEncontesa = false;
    domicilioNormalizado = Object.assign(
      {},
      domicilioNormalizado,
      respuesta.domicilio
    );
  }

  // Hardcodeamos la localidad
  domicilioNormalizado.localidad = localidad;
  return domicilioNormalizado;
};

const incluyeCodigoErrorContinuaSucursal = errores => {
  /**
   * Función para chequear la presencia de códigos de error particulares. La presencia de los mismos
   * indica que el cliente debe redirigirse a una sucursal.
   */
  if (!errores) {
    return false;
  }
  return errores.some(error =>
    ERROR_CODES_CONTINUA_SUCURSAL.some(code => error.includes(code))
  );
};

const setearConsulta = (response, respuesta, context) => {
  if (response.payloadSuccess.hash) {
    const consulta = respuesta.evaluacionCompleta;
    const fechaNacimiento = consulta.fechaNacimiento.split("-");
    context.commit(MUTATIONS.ON_CONSULTA, {
      nombre: consulta.nombres,
      apellido: consulta.apellidos,
      tipoDoc: consulta.tipoDocumento,
      nroDoc: consulta.numeroDocumento,
      numeroDoc: consulta.numeroDocumento,
      fechaNacimiento: `${fechaNacimiento[2]}/${fechaNacimiento[1]}/${fechaNacimiento[0]}`,
      nacionalidad: consulta.codigoNacionalidad,
      sexo: consulta.sexo,
      email: consulta.email,
      circuito: respuesta.circuitoVentas
    });
  }
};

const doDispatchSegunMensaje = (context, tipoMje) => {
  switch (tipoMje) {
    case "mensaje-7":
      context.dispatch(ACTIONS.DO_MENSAJE, INDIVIDUO_NEGATIVO);
      return true;
    case "mensaje-5":
      if (context.state.confirmarRenaper.yaValido) {
        context.dispatch(ACTIONS.DO_MENSAJE, ERROR_CONFIRMACION_RENAPER);
        return true;
      }
      router.push("confirmar-datos");
      context.commit(MUTATIONS.ON_CONFIRMAR_RENAPER_FLAG, true);
      return true;
    case "mensaje-4":
      context.dispatch(ACTIONS.DO_MENSAJE, ERROR_TECNICO);
      return true;
  }
  return false;
};
const doCaminoOfertaNomina = (context, respuesta, caminoKey, oferta) => {
  context.commit(MUTATIONS.ON_OFFER, respuesta);
  context.commit(
    MUTATIONS.ON_QUERY,
    get(respuesta, "respuestaCaminosClientes", null)
  );

  const destino = caminos[caminoKey];

  if (!destino) {
    Vue.$log.error(respuesta);
    context.dispatch(ACTIONS.DO_MENSAJE, ERROR_TECNICO);
    return;
  }
  router.push(destino);

  if (oferta.dictamen == "APROBADO") {
    context.dispatch(ACTIONS.DO_PASO_CARRO_ABANDONADO, {
      paso: "oferta"
    });
  }
  return;
};
const doCaminoOfertaEmprendedores = (context, payloadSuccess) => {
  const payload = payloadSuccess.nroDoc
    ? payloadSuccess
    : get(context, "state.consulta", "");
  context.dispatch(ACTIONS.DO_REQUEST_API, {
    endPoint: END_POINTS.CONSULTAR_CUENTA_CLIENTE_EMPRENDEDORES,
    doSuccess: ACTIONS.DO_CONSULTA_CUENTA_CLIENTE_SUCCESS,
    doError: ACTIONS.DO_CONSULTA_ERROR,
    payload: payload
  });
  return;
};

export default {
  /**
   * Action disparada por el router en
   * cada actualización
   * @param {Object} context
   * @param {Object} payload
   */
  [ACTIONS.DO_ROUTE](context, payload) {
    context.commit(MUTATIONS.ON_ROUTE, payload);
    if (payload.name !== "consulta" && payload.name !== "contrato") {
      setTimeout(() => {
        // Detener loading al ingresar a ruta nueva
        // Lo hacemos en un timeout = 0 para hacer
        // al final del event loop
        context.commit(MUTATIONS.ON_IS_LOADING, false);
      }, 0);
    }
  },
  /**
   * Mostrar u ocultar el loader
   * @param {Object} context
   * @param {Object} payload
   */
  [ACTIONS.DO_IS_LOADING](context, payload) {
    context.commit(MUTATIONS.ON_IS_LOADING, payload);
  },
  /**
   * Action para mostrar notificaciones en el front
   * en modo "toast"
   * @param {Object} context
   * @param {Object} payload: {type: String ["info", "success", "alert"], message: String}
   */
  [ACTIONS.DO_NOTIFICATION_TOAST](context, payload) {
    context.commit(MUTATIONS.ON_NOTIFICATION_TOAST, payload);
    setTimeout(() => {
      // Luego de 3 segundos quitamos la notificacion
      context.dispatch(ACTIONS.DO_NOTIFICATION_TOAST_RESET);
    }, 3000);
  },
  [ACTIONS.DO_NOTIFICATION_TOAST_RESET](context) {
    context.commit(MUTATIONS.ON_NOTIFICATION_TOAST, {
      type: "",
      message: ""
    });
  },
  /**
   * Action genérico para llamadas a la API
   * Se debe pasar el endpoint, el action a ejecutar en caso
   * de éxito y el action en caso de error
   * @param {Object} context Vue Context
   * @param {endPoint, payload, doSuccess, doError} actionPayload
   * @param payloadSuccess: objeto para pasar al action doSuccess
   */
  [ACTIONS.DO_REQUEST_API](
    context,
    { endPoint, payload, doSuccess, doError, payloadSuccess, payloadError }
  ) {
    om.request({ endPoint, body: payload, mock: context.state.mock })
      .then(response => {
        context.dispatch(doSuccess, {
          ...response.data,
          ...{ payloadSuccess }
        });
      })
      .catch(error => {
        context.dispatch(doError, { ...error, ...{ payloadError } });
      });
  },
  [ACTIONS.DO_FORZAR_DNE]({ commit }, payload) {
    commit("ON_FORZAR_DNE", payload);
  },
  /**
   * Actions disparadas por el
   * step navigator para avanzar pasos
   * Cada action guarda el paso
   * actual en el store
   * @param {Object} context
   */
  [ACTIONS.DO_LANDING]: (context, payload) => {
    context.commit(MUTATIONS.ON_IS_LOADING, true);
    context.commit(MUTATIONS.ON_LANDING, payload);
    context.commit(MUTATIONS.ADOBE_APP_ON_CLICK_START, payload);
    router.push("consulta");
  },
  [ACTIONS.DO_CONSULTAR_RENAPER]: (context, payload) => {
    context.commit(MUTATIONS.ON_IS_LOADING, true);
    context.commit(MUTATIONS.ON_CONFIRMAR_RENAPER, payload);
    payload = {
      nombre: context.getters.getConsulta().nombre,
      apellido: context.getters.getConsulta().apellido,
      nroDoc: context.getters.getConsulta().numeroDoc,
      tipoDoc: context.getters.getConsulta().tipoDoc,
      nacionalidad: context.getters.getConsulta().nacionalidad,
      sexo: context.getters.getConsulta().sexo,
      fechaNacimiento: context.getters.getConsulta().fechaNacimiento,
      expediente: payload.expediente
    };

    context.dispatch(ACTIONS.DO_REQUEST_API, {
      endPoint: END_POINTS.CONFIRMAR_RENAPER,
      doSuccess: ACTIONS.DO_CONSULTAR_RENAPER_SUCCESS,
      doError: ACTIONS.DO_CONSULTAR_RENAPER_ERROR,
      payload
    });
  },
  [ACTIONS.DO_CONSULTAR_RENAPER_SUCCESS]: (context, payload) => {
    if (payload.status === "OK") {
      // si tenemos respuesta exitosa, intentar nuevamente la evaluación
      // con los datos ingresados por el cliente
      context.dispatch(ACTIONS.DO_QUERY, context.getters.getConsulta());
    } else {
      // Ocurrió un error, mostramos pantalla
      context.dispatch(ACTIONS.DO_MENSAJE, ERROR_CONFIRMACION_RENAPER);
      context.commit(MUTATIONS.ON_IS_LOADING, false);
    }
  },
  [ACTIONS.DO_CONSULTAR_RENAPER_ERROR]: (context, payload) => {
    // Ocurrió un error TECNICO, mostramos pantalla
    Vue.$log.error(payload);
    context.commit(MUTATIONS.ON_IS_LOADING, false);
    context.dispatch(ACTIONS.DO_MENSAJE, ERROR_TECNICO);
  },
  [ACTIONS.DO_PASO_CARRO_ABANDONADO]: (context, { paso }) => {
    const tCode = context.getters.getTCode();
    const consultaData = context.getters.getConsulta();
    const ofertaData = context.getters.getOferta();
    const paso1 = context.getters.getPaso1();
    const paso2 = context.getters.getPaso2();
    const paso3 = context.getters.getPaso3();
    const paso4 = context.getters.getPaso4();

    const consulta = { ...consultaData, c: `${_BBVA_MOTOR}${tCode}` };
    const oferta = { ...ofertaData };
    const randomKey = oferta.carro;

    delete oferta.carro;
    delete oferta.randomkey;

    const dataPayload = {
      consulta,
      oferta,
      paso1,
      paso2,
      paso3,
      paso4
    };

    let payload = {
      randomKey,
      paso,
      datos: JSON.stringify(dataPayload),
      circuito: oferta.dictamen == "APROBADO" ? "nominas" : ""
    };
    context.dispatch(ACTIONS.DO_REQUEST_API, {
      endPoint: END_POINTS.PERSISTIR_NUEVO_PASO,
      doSuccess: ACTIONS.DO_PASO_CARRO_ABANDONADO_SUCCESS,
      doError: ACTIONS.DO_PASO_CARRO_ABANDONADO_ERROR,
      payload
    });
  },
  [ACTIONS.DO_PASO_CARRO_ABANDONADO_SUCCESS]: (context, payload) => {
    Vue.$log.info("Paso guardado en CA", payload.respuesta);
  },
  [ACTIONS.DO_PASO_CARRO_ABANDONADO_ERROR]: (context, payload) => {
    Vue.$log.error("Error grabando CA: " + payload);
  },
  [ACTIONS.DO_PASO1]: (context, payload) => {
    let domicilioMerlin = Object.assign({}, payload);
    context.commit(MUTATIONS.ON_IS_LOADING, true);
    if (
      context.getters.getPaso1().domicilioParticular.valido &&
      context.getters.getPaso1().domicilioParticular.valido === true
    ) {
      context.commit(MUTATIONS.ON_IS_LOADING, false);
      router.push("paso2");
    } else {
      payload = {
        randomKey: get(context, "state.dataOferta.randomkey", ""),
        domicilio: {
          calle: get(domicilioMerlin, "domicilioParticular.calle", ""),
          numero: get(domicilioMerlin, "domicilioParticular.numero", ""),
          piso: get(domicilioMerlin, "domicilioParticular.piso", ""),
          departamento: get(domicilioMerlin, "domicilioParticular.dpto", ""),
          codigoPostal: get(
            domicilioMerlin,
            "domicilioParticular.codigoPostal",
            ""
          ),
          localidad: get(domicilioMerlin, "domicilioParticular.localidad", ""),
          provincia: get(
            domicilioMerlin,
            "domicilioParticular.codProvincia",
            ""
          )
        }
      };
      context.dispatch(ACTIONS.DO_REQUEST_API, {
        endPoint: END_POINTS.MERLIN,
        doSuccess: ACTIONS.DO_PASO1_SUCCESS,
        doError: ACTIONS.DO_PASO1_ERROR,
        payload
      });
    }
  },
  [ACTIONS.DO_PASO1_SUCCESS]: (context, payload) => {
    const respuesta = payload.respuesta;
    let dataPaso1 = Object.assign({}, context.getters.getPaso1());
    if (payload.status === "ERROR") {
      dataPaso1.domicilioParticular.valido = false;
    }
    dataPaso1.domicilioParticular = aplicarNormalizacion(
      respuesta,
      dataPaso1.domicilioParticular
    );
    context.commit(MUTATIONS.ON_PASO_1, dataPaso1);
    context.commit(MUTATIONS.ON_IS_LOADING, false);
    if (dataPaso1.domicilioParticular.valido) {
      router.push("paso2");
      context.dispatch(ACTIONS.DO_PASO_CARRO_ABANDONADO, {
        paso: "paso1"
      });
    }
  },
  [ACTIONS.DO_PASO1_ERROR]: (context, payload) => {
    Vue.$log.error(payload);
    context.commit(MUTATIONS.ON_IS_LOADING, false);
  },
  [ACTIONS.DO_PASO2]: (context, payload) => {
    router.push("paso3");
    context.commit(MUTATIONS.ON_PASO_2, payload);
    context.dispatch(ACTIONS.DO_PASO_CARRO_ABANDONADO, {
      paso: "paso2"
    });
  },
  [ACTIONS.DO_PASO3]: (context, payload) => {
    context.commit(MUTATIONS.ON_PASO_3, payload);
    // Verifico que no haya elegido PEP o SO
    if (
      get(payload, "pep", "0") === "1" ||
      get(payload, "sujetoObligado", "0") === "1" ||
      get(payload, "fatca", "0") === "1"
    ) {
      router.push({
        name: "continuaSucursal",
        params: { mensaje: "mensaje-1" }
      });
      return;
    }
    // Envío al paso siguiente
    router.push(config.pasos[config.pasos.paso3.pasoSiguiente].path);
    context.dispatch(ACTIONS.DO_PASO_CARRO_ABANDONADO, {
      paso: "paso3"
    });
  },
  [ACTIONS.DO_NORMALIZAR_DOMICILIO]: (context, payload) => {
    let domicilioMerlin = Object.assign({}, payload.payload);
    if (domicilioMerlin.valido) {
      if (payload.selectDomicilio === "otro") {
        context.commit(MUTATIONS.ON_NORMALIZAR_DOMICILIO_ALTE, domicilioMerlin);
      } else {
        context.commit(MUTATIONS.ON_NORMALIZAR_DOMICILIO_PART, domicilioMerlin);
      }
      return true;
    } else {
      const payloadMerlin = {
        randomKey: get(context, "state.dataOferta.randomkey", ""),
        domicilio: {
          calle: get(domicilioMerlin, "calle", ""),
          numero: get(domicilioMerlin, "numero", ""),
          piso: get(domicilioMerlin, "piso", ""),
          departamento: get(domicilioMerlin, "dpto", ""),
          codigoPostal: get(domicilioMerlin, "codigoPostal", ""),
          barrio: "",
          localidad: get(domicilioMerlin, "localidad", ""),
          provincia: get(domicilioMerlin, "codProvincia", "")
        }
      };
      context.commit(MUTATIONS.ON_IS_LOADING, true);

      context.dispatch(ACTIONS.DO_REQUEST_API, {
        endPoint: END_POINTS.MERLIN,
        doSuccess: ACTIONS.DO_NORMALIZAR_DOMICILIO_SUCCESS,
        doError: ACTIONS.DO_NORMALIZAR_DOMICILIO_ERROR,
        payload: payloadMerlin,
        payloadSuccess: { selectDomicilio: payload.selectDomicilio }
      });
    }
  },
  [ACTIONS.DO_NORMALIZAR_DOMICILIO_SUCCESS]: (context, payload) => {
    const respuesta = payload.respuesta;
    let domicilioMerlin = Object.assign({}, get(respuesta, "domicilio", {}));

    if (payload.status === "ERROR") {
      domicilioMerlin.valido = false;
    }

    domicilioMerlin = aplicarNormalizacion(respuesta, domicilioMerlin);

    context.commit(MUTATIONS.ON_IS_LOADING, false);
    if (get(payload, "payloadSuccess.selectDomicilio", "") === "otro") {
      context.commit(MUTATIONS.ON_NORMALIZAR_DOMICILIO_ALTE, domicilioMerlin);
    } else {
      context.commit(MUTATIONS.ON_NORMALIZAR_DOMICILIO_PART, domicilioMerlin);
    }
    return domicilioMerlin.valido;
  },
  [ACTIONS.DO_NORMALIZAR_DOMICILIO_ERROR]: (context, payload) => {
    Vue.$log.error(payload);
    context.commit(MUTATIONS.ON_IS_LOADING, false);
  },
  [ACTIONS.DO_SELECT_PARTICULAR]: (context, payload) => {
    let commitPayloadStep1 = deepmerge.all(
      [
        {},
        context.state.paso1,
        {
          domicilioParticular: {
            searchEncontesa: false,
            lineas: [],
            calle: payload.calleLocalidad,
            codigoPostal: payload.codigoPostal,
            valido: true
          }
        }
      ],
      { arrayMerge: (a, b) => b }
    );
    let commitPayloadStep4 = deepmerge.all(
      [
        {},
        context.state.paso4,
        {
          domicilioParticular: {
            searchEncontesa: false,
            lineas: [],
            calle: payload.calleLocalidad,
            codigoPostal: payload.codigoPostal,
            valido: true
          }
        }
      ],
      { arrayMerge: (a, b) => b }
    );
    context.commit(MUTATIONS.ON_PASO_1, commitPayloadStep1);
    context.commit(MUTATIONS.ON_PASO_4, commitPayloadStep4);
  },
  [ACTIONS.DO_SELECT_ALTERNATIVO](context, payload) {
    let commitPayload = deepmerge.all(
      [
        {},
        context.state.paso4,
        {
          otroDomicilio: {
            searchEncontesa: false,
            lineas: [],
            calle: payload.calleLocalidad,
            codigoPostal: payload.codigoPostal,
            valido: true
          }
        }
      ],
      { arrayMerge: (a, b) => b }
    );
    context.commit(MUTATIONS.ON_PASO_4, commitPayload);
  },
  [ACTIONS.DO_CONFIRMAR_DATA]: context => {
    context.commit(MUTATIONS.ON_IS_LOADING, true);
    let payload = context.getters.getConfirmacionData();

    context.dispatch(ACTIONS.DO_REQUEST_API, {
      endPoint: END_POINTS.CONFIRMAR,
      doSuccess: ACTIONS.DO_GRACIAS,
      doError: ACTIONS.DO_PASO4_ERROR,
      payload
    });
  },
  [ACTIONS.DO_PASO4_ERROR]: (context, payload) => {
    Vue.$log.error(payload);
    context.commit(MUTATIONS.ON_IS_LOADING, false);
    context.dispatch(ACTIONS.DO_MENSAJE, ERROR_TECNICO);
  },
  [ACTIONS.DO_CONSULTA_ESCLIENTE]: context => {
    context.commit(MUTATIONS.ON_IS_LOADING, true);
    let consulta = context.getters.getConsulta();
    let payload = {
      nombre: consulta.nombre,
      apellido: consulta.apellido,
      tipoDocumento: consulta.tipoDoc,
      numeroDocumento: consulta.numeroDoc,
      sexo: consulta.sexo,
      fechaNacimiento: consulta.fechaNacimiento,
      paisCodigo: consulta.nacionalidad,
      email: consulta.email,
      celularNumero:
        get(consulta, "celular.area", "") + get(consulta, "celular.numero", "")
    };

    context.dispatch(ACTIONS.DO_REQUEST_API, {
      endPoint: END_POINTS.CONSULTA_ESCLIENTE,
      doSuccess: ACTIONS.DO_CONSULTA_ESCLIENTE_SUCCESS,
      doError: ACTIONS.DO_CONSULTA_ESCLIENTE_ERROR,
      payload
    });
  },
  [ACTIONS.DO_CONSULTA_ESCLIENTE_SUCCESS]: (context, payload) => {
    context.commit(MUTATIONS.ON_IS_LOADING, false);
    if (payload.respuesta === "CLIENTE") {
      router.push("clienteCA");
    } else if (payload.respuesta === "NO_CLIENTE") {
      router.push("ofertaCA");
    } else {
      context.dispatch(ACTIONS.DO_MENSAJE, ERROR_TECNICO);
    }
  },
  [ACTIONS.DO_CONSULTA_ESCLIENTE_ERROR]: context => {
    context.commit(MUTATIONS.ON_IS_LOADING, false);
    context.dispatch(ACTIONS.DO_MENSAJE, ERROR_TECNICO);
  },
  [ACTIONS.DO_CONFIRMAR_DATA_NOCLIENTE]: (context, payload) => {
    let apiPayload = {
      sucursal: context.getters.getDataQuery().sucursal,
      nroCliente: context.getters.getDataOferta().oferta.numeroCliente,
      nombre: payload.nombre,
      apellido: payload.apellido,
      email: payload.email,
      celular: payload.celular.area + " " + payload.celular.numero,
      numeroDoc: payload.numeroDoc,
      tipoDoc: payload.tipoDoc
    };

    context.commit(MUTATIONS.ON_IS_LOADING, true);

    context.dispatch(ACTIONS.DO_REQUEST_API, {
      endPoint: END_POINTS.CONFIRMAR_DATA_NOCLIENTE,
      doSuccess: ACTIONS.DO_GRACIAS_NOCLIENTE,
      doError: ACTIONS.DO_QUERY_ERROR,
      payload: apiPayload
    });
  },
  [ACTIONS.DO_GRACIAS_NOCLIENTE]: context => {
    context.commit(MUTATIONS.ON_IS_LOADING, false);
    router.push("noCliente");
  },
  /**
   * Action que permite a Adobe Target inyectar en el store
   * el código de la actividad que debe seleccionarse
   * @uso (desde afuera): BBVA_APP.$store.dispatch('SET_ADOBE_TARGET_EXPERIENCE', 'AR062019_B')
   */
  [ACTIONS.SET_ADOBE_TARGET_EXPERIENCE]: (context, payload) => {
    context.commit(MUTATIONS.ON_ADOBE_TARGET_EXPERIENCE, payload);
  },
  [ACTIONS.DO_GRACIAS]: (context, payload) => {
    context.commit(MUTATIONS.ON_IS_LOADING, false);
    if (payload && payload.status === "ERROR") {
      Vue.$log.error(payload);
      if (incluyeCodigoErrorContinuaSucursal(payload.respuesta?.errores)) {
        router.push({
          name: "continuaSucursal"
        });
        return;
      }
      context.dispatch(ACTIONS.DO_MENSAJE, ERROR_TECNICO);
    } else if (
      payload &&
      payload.respuesta &&
      payload.respuesta.mensaje === "INDIVIDUO_NEGATIVO"
    ) {
      Vue.$log.error(payload);
      context.dispatch(ACTIONS.DO_MENSAJE, INDIVIDUO_NEGATIVO);
    } else if (
      payload &&
      payload.respuesta &&
      payload.respuesta.mensaje === "clienteNoCensado"
    ) {
      Vue.$log.error(payload);
      context.dispatch(ACTIONS.DO_MENSAJE, CLIENTE_NO_CENSADO);
    } else {
      context.commit(MUTATIONS.ON_GRACIAS, payload);
      if (
        context.getters.getDataQuery() &&
        context.getters.getDataQuery().camino !== 1
      )
        router.push("gracias");
    }
  },
  [ACTIONS.DO_SUCURSAL]: (context, payload) => {
    payload.cuil = payload.cuil.replace(/\D/g, "");
    context.commit(MUTATIONS.ON_SUCURSAL, payload);
    context.dispatch(ACTIONS.DO_CONFIRMAR_DATA_SUCURSAL);
  },
  [ACTIONS.DO_CONFIRMAR_DATA_SUCURSAL]: context => {
    context.commit(MUTATIONS.ON_IS_LOADING, true);
    let consulta = context.getters.getConsulta();
    let sucursal = context.getters.getSucursal();
    let nroCelular = consulta.celular.area + consulta.celular.numero;
    let payload = {
      nombre: consulta.nombre,
      apellido: consulta.apellido,
      tipoDocumento: consulta.tipoDoc,
      numeroDocumento: consulta.numeroDoc,
      sexo: consulta.sexo,
      fechaNacimiento: consulta.fechaNacimiento,
      paisCodigo: consulta.nacionalidad,
      celularNumero: nroCelular,
      numeroSucursal: sucursal.sucursal,
      email: consulta.email,
      cuil: sucursal.cuil
    };
    let endpoint = "";
    switch (_BBVA_MOTOR) {
      case "ofertaCGU":
        endpoint = END_POINTS.ALTA_CLIENTE_CGU;
        break;
      case "ofertaCajaAhorro":
        endpoint = END_POINTS.ALTA_CLIENTE_CAJA_AHORRO;
        break;
      case "ofertaEmprendedores":
        endpoint = END_POINTS.ALTA_CLIENTE_CAJA_AHORRO;
        break;
      default:
        endpoint = END_POINTS.ALTA_CLIENTE_CA;
        break;
    }
    context.dispatch(ACTIONS.DO_REQUEST_API, {
      endPoint: endpoint,
      doSuccess: ACTIONS.DO_GRACIAS_CA,
      doError: ACTIONS.DO_SUCURSAL_ERROR,
      payload
    });
  },
  [ACTIONS.DO_SUCURSAL_ERROR]: (context, payload) => {
    Vue.$log.error(payload);
    context.commit(MUTATIONS.ON_IS_LOADING, false);
    context.dispatch(ACTIONS.DO_MENSAJE, ERROR_TECNICO);
  },
  [ACTIONS.DO_GRACIAS_CA]: (context, payload) => {
    context.commit(MUTATIONS.ON_IS_LOADING, false);
    if (payload && payload.status === "OK" && payload.respuesta === "CLIENTE") {
      Vue.$log.error(payload);
      router.push("clienteCA");
    } else if (
      payload &&
      payload.status === "ERROR" &&
      payload.respuesta === "YA_CONVERTIDO"
    ) {
      Vue.$log.error(payload);
      context.dispatch(ACTIONS.DO_MENSAJE, INDIVIDUO_NEGATIVO);
    } else if (payload && payload.status === "ERROR") {
      if (
        payload.respuesta.includes("JAHE160") ||
        payload.respuesta.includes("AHE0160")
      ) {
        router.push("errorBBVAVos");
      } else {
        Vue.$log.error(payload);
        context.dispatch(ACTIONS.DO_MENSAJE, ERROR_TECNICO);
      }
    } else {
      context.commit(MUTATIONS.ON_GRACIAS_CA, payload);
      router.push("graciasCA");
    }
  },
  [ACTIONS.DO_SOLICITAR_TURNO](context, payload) {
    context.commit(MUTATIONS.ON_SOLICITAR_TURNO, payload);
  },
  [ACTIONS.DO_SOCIAL_NET]: (context, payload) => {
    //Redefino payload para SocialNet
    payload = {
      caracteristicaTel: payload.celular.area,
      nroTel: payload.celular.numero,
      randomKey: context.getters.getDataOferta().randomkey
    };
    context.commit(MUTATIONS.ON_IS_LOADING, true);

    context.dispatch(ACTIONS.DO_REQUEST_API, {
      endPoint: END_POINTS.SOCIAL_NET,
      doSuccess: ACTIONS.DO_SOCIAL_NET_SUCCESS,
      doError: ACTIONS.DO_SOCIAL_NET_ERROR,
      payload
    });
  },
  [ACTIONS.DO_SOCIAL_NET_ERROR]: (context, payload) => {
    Vue.$log.error(payload);
    context.commit(MUTATIONS.ON_SOCIAL_NET_STATUS, payload);
  },
  [ACTIONS.DO_SOCIAL_NET_SUCCESS]: (context, payload) => {
    if (!payload.respuesta.status) {
      payload = "ERROR";
    } else {
      payload = "SUCCESS";
    }
    context.commit(MUTATIONS.ON_IS_LOADING, false);
    context.commit(MUTATIONS.ON_SOCIAL_NET_STATUS, payload);
  },
  /**
   * Mostrar un mensaje de error
   * @param {Object} context
   * @param {Object} payload Código del mensaje
   */
  [ACTIONS.DO_MENSAJE]: (context, payload) => {
    router.push({
      name: "mensaje",
      params: {
        mje: payload
      }
    });
  },
  [ACTIONS.DO_SEARCH_ENCOTESA]: (context, payload) => {
    payload.domicilio.departamento = payload.domicilio.depto;
    payload.domicilio.provincia = payload.domicilio.codProvincia;
    let body = {
      domicilio: payload.domicilio,
      orden: payload.searchType
    };
    payload = body;
    context.dispatch(ACTIONS.DO_REQUEST_API, {
      endPoint: END_POINTS.SEARCH_ENCOTESA,
      doSuccess: ACTIONS.DO_SEARCH_ENCOTESA_SUCCESS,
      doError: ACTIONS.DO_SEARCH_ENCOTESA_ERROR,
      payload
    });
  },
  [ACTIONS.DO_SEARCH_ENCOTESA_SUCCESS]: (context, payload) => {
    if (payload.status === "OK") {
      let respuesta = payload.respuesta;
      context.commit(MUTATIONS.ON_SEARCH_ENCOTESA, respuesta.domicilios);
    }
  },
  [ACTIONS.DO_SEARCH_ENCOTESA_ERROR]: context => {
    context.dispatch(ACTIONS.DO_MENSAJE, ERROR_TECNICO);
  },
  [ACTIONS.DO_CLICK_TRACKING]: (context, payload) => {
    // El evento de click solo debe trackearse con el primer elemento
    // que interactúa
    if (context.state.trackClickElement === null) {
      context.commit(MUTATIONS.ADOBE_APP_STARTED, payload);
    }
  },
  [ACTIONS.DO_INTERNAL_LINK]: (context, payload) => {
    context.commit(MUTATIONS.ON_INTERNAL_LINK, payload);
  },
  [ACTIONS.DO_INGRESO_BANCA_ONLINE]: context => {
    context.commit(
      MUTATIONS.ON_INGRESO_BANCA_ONLINE,
      context.getters.getRoute().name
    );
  },
  [ACTIONS.DO_MOCK]: (context, payload) => {
    context.commit(MUTATIONS.ON_MOCK, payload);
  },
  [ACTIONS.DO_OPEN_MODAL]: (context, payload) => {
    context.commit("ON_OPEN_MODAL", payload);
  },
  [ACTIONS.doSelectEncotesaParticular]: (context, payload) => {
    context.commit(MUTATIONS.onSelectEncotesaParticular, payload);
  },
  [ACTIONS.doSelectEncotesaAlternativo]: (context, payload) => {
    context.commit(MUTATIONS.onSelectEncotesaAlternativo, payload);
  },
  [ACTIONS.doTCode]: (context, payload) => {
    context.commit(MUTATIONS.onTCode, payload);
  },
  [ACTIONS.DO_GET_DEVICEID]: (context, payload) => {
    context.commit(MUTATIONS.ON_DEVICEID, payload);
  },
  [ACTIONS.DO_GET_DEVICEIDTIMESTAMP]: (context, payload) => {
    context.commit(MUTATIONS.ON_DEVICEIDTIMESTAMP, payload);
  },
  [ACTIONS.DO_GET_TOKEN_USER_ID]: (context, payload) => {
    context.dispatch(ACTIONS.DO_REQUEST_API, {
      endPoint: END_POINTS.TOKENIZAR_USER,
      doSuccess: ACTIONS.DO_TOKENIZAR_USER_SUCCESS,
      doError: ACTIONS.DO_TOKENIZAR_USER_ERROR,
      payload
    });
  },
  [ACTIONS.DO_TOKENIZAR_USER_SUCCESS]: (context, response) => {
    if (response.status === "OK") {
      let userIdTokenizado = response.respuesta.customerID;
      context.commit(MUTATIONS.ON_USER_TOKENIZADO, userIdTokenizado);
    }
  },
  [ACTIONS.DO_TOKENIZAR_USER_ERROR]: (context, error) => {
    Vue.$log.error(error);
  },
  [ACTIONS.DO_CONSULTA]: (context, payload) => {
    let payloadAux;
    if (getParameterByName("hash")) {
      //ver si hace falta
      payloadAux = payload;
      payloadAux.c = _BBVA_MOTOR + context.getters.getTCode();
    } else {
      Vue.$log.info("Datos " + payload);
      payloadAux = {
        nombre: payload.nombre,
        apellido: payload.apellido,
        tipoDoc: payload.tipoDoc,
        nroDoc: payload.numeroDoc,
        numeroDoc: payload.numeroDoc,
        nacionalidad: payload.nacionalidad,
        sexo: payload.sexo,
        fechaNacimiento: payload.fechaNacimiento,
        email: payload.email,
        caracteristicaTel: payload.caracteristicaTel || payload.celular.area,
        nroTel: payload.nroTel || payload.celular.numero,
        captchaResponse: payload.captcha,
        tipoResidencia: "",
        c: _BBVA_MOTOR + context.getters.getTCode(),
        fingerprint: "9999991212",
        referrer: window.document.referrer,
        originUrl: window.location.href
      };

      switch (_BBVA_MOTOR) {
        case "ofertaCGU":
          payloadAux.circuito = circuitos.CGU;
          break;
        case "ofertaCajaAhorro":
          payloadAux.circuito = circuitos.CA_SUELTA;
          break;
        case "ofertaEmprendedores":
          payloadAux.circuito = circuitos.CA_EMPRENDEDORES;
          break;
        // You may add a default case if needed
      }
      context.commit(MUTATIONS.ON_CONSULTA, { ...payload, ...payloadAux });
    }

    context.dispatch(ACTIONS.DO_REQUEST_API, {
      endPoint: END_POINTS.CONSULTAR_OFERTA,
      doSuccess: ACTIONS.DO_CONSULTA_SUCCESS,
      doError: ACTIONS.DO_CONSULTA_ERROR,
      payload: payloadAux,
      payloadSuccess: payloadAux
    });
  },
  [ACTIONS.DO_CONSULTA_SUCCESS]: (context, response) => {
    const respuesta = response.respuesta;

    if (
      respuesta.validacionRiesgosResponse?.validacionCoelsaExitosa === false
    ) {
      router.push({
        name: "continuaSucursal",
        params: { mensaje: "mensaje-2" }
      });
      return;
    }

    if (
      get(response, "status", "ERROR") === "ERROR" ||
      get(respuesta, "mensaje", "ok") === "error"
    ) {
      if (respuesta.includes("CA ACTIVA")) {
        if (_BBVA_MOTOR === "ofertaEmprendedores") {
          doCaminoOfertaEmprendedores(context, response.payloadSuccess);
          return;
        }
        router.push({
          name: "mensajeErrorSolicitudCuenta",
          params: {
            mje: ERROR_SOLICITUD
          }
        });
        return;
      }
      context.dispatch(ACTIONS.DO_MENSAJE, ERROR_CONEXION);
      return;
    }
    const oferta = respuesta.oferta;
    if (!oferta) {
      context.dispatch(ACTIONS.DO_MENSAJE, ERROR_TECNICO);
      return;
    }
    const tipoMje = get(oferta, "tipoMje", "");
    const hash = get(respuesta, "evaluacionCompleta.hash", "");
    window.hash = hash;

    if (doDispatchSegunMensaje(context, tipoMje)) return;

    setearConsulta(response, respuesta, context);

    context.dispatch(ACTIONS.DO_GET_TOKEN_USER_ID, {
      nroCliente: oferta.numeroCliente
    });

    oferta.nroDeTramite = get(respuesta, "nroDeTramite", "");
    oferta.randomkey = get(respuesta, "randomkey", "");

    oferta.valid = true;

    const caminoKey = get(respuesta.respuestaCaminosClientes, "camino", null);
    context.commit(
      MUTATIONS.ON_QUERY,
      get(respuesta, "respuestaCaminosClientes", null)
    );
    if (_BBVA_MOTOR === "ofertaNomina") {
      if (caminoKey !== "1") {
        doCaminoOfertaNomina(context, respuesta, caminoKey, oferta);
        return;
      }
      context.commit(MUTATIONS.ON_CONSULTA, {
        circuito: circuitos.CA_NOMINA
      });
    }
    context.commit(MUTATIONS.ON_OFERTA, respuesta);

    context.commit(
      MUTATIONS.ON_SEGMENTO_SCORE_CLIENTE,
      get(oferta, "segmentoScoreCliente", null)
    );

    if (_BBVA_MOTOR === "ofertaEmprendedores") {
      doCaminoOfertaEmprendedores(context, response.payloadSuccess);
      return;
    }
    if (hash) {
      router.push("/dummy").then(() => {
        router.replace(config.pasos.ofertaCuenta.path);
      });
      return;
    }
    router.push(config.pasos.ofertaCuenta.path);
  },
  [ACTIONS.DO_CONSULTA_CUENTA_CLIENTE_SUCCESS]: (context, payload) => {
    context.commit(MUTATIONS.ON_CUENTA, payload.respuesta.cuenta);
    router.push(config.pasos.ofertaCuenta.path);
  },
  [ACTIONS.DO_CONSULTA_ERROR]: (context, error) => {
    Vue.$log.error(error);
    context.dispatch(ACTIONS.DO_MENSAJE, ERROR_CONEXION);
  },
  [ACTIONS.DO_ENVIO_SMS]: (context, payload) => {
    context.dispatch(ACTIONS.DO_REQUEST_API, {
      endPoint: END_POINTS.ENVIAR_SMS,
      doSuccess: ACTIONS.DO_ENVIO_SMS_SUCCESS,
      doError: ACTIONS.DO_ENVIO_SMS_ERROR,
      payload: payload
    });
  },
  [ACTIONS.DO_ENVIO_SMS_SUCCESS]: (context, data) => {
    if (data.status === "ERROR") {
      context.dispatch(ACTIONS.DO_NOTIFICATION_TOAST, {
        type: "alert",
        message: "Hubo un error en el envío. Intente nuevamente."
      });
    } else {
      context.dispatch(ACTIONS.DO_NOTIFICATION_TOAST, {
        type: "success",
        message: "Se envió el SMS."
      });
    }
  },
  [ACTIONS.DO_ENVIO_SMS_ERROR]: (context, error) => {
    Vue.$log.error(error);
    context.dispatch(ACTIONS.DO_NOTIFICATION_TOAST, {
      type: "alert",
      message: "Hubo un error en el envío. Intente nuevamente."
    });
  },
  [ACTIONS.DO_NORMALIZAR_NUMERO]: (context, payload) => {
    const body = {
      level1: "AR",
      level2: "",
      level3: "",
      level4: "",
      level5: "",
      phoneNumber: payload,
      characteristic: "",
      postalCode: "",
      prefix: "",
      additionalData: ""
    };
    context.dispatch(ACTIONS.DO_REQUEST_API, {
      endPoint: END_POINTS.NORMALIZAR_NUMERO,
      doSuccess: ACTIONS.DO_NORMALIZAR_NUMERO_SUCCESS,
      doError: ACTIONS.DO_NORMALIZAR_NUMERO_ERROR,
      payload: body
    });
  },
  [ACTIONS.DO_NORMALIZAR_NUMERO_SUCCESS]: (context, response) => {
    const respuesta = response.respuesta;
    context.dispatch(ACTIONS.DO_NORMALIZAR_CELULAR, respuesta);
  },
  [ACTIONS.DO_NORMALIZAR_NUMERO_ERROR]: (context, error) => {
    Vue.$log.error(error);
  },
  [ACTIONS.DO_CONSULTAR_DOMICILIO]: context => {
    const tDomics = [PCG7.TDOMIC.PARTICULAR, PCG7.TDOMIC.CORRESPONDENCIA];

    context.commit(MUTATIONS.ON_IS_LOADING, true);

    for (let tDomic of tDomics) {
      const payload = {
        numClie: context.getters.getNumeroCliente(),
        tDomic
      };
      context.dispatch(ACTIONS.DO_REQUEST_API, {
        endPoint: END_POINTS.CONSULTAR_DOMICILIO,
        doSuccess: ACTIONS.DO_CONSULTAR_DOMICILIO_SUCCESS,
        doError: ACTIONS.DO_CONSULTAR_DOMICILIO_ERROR,
        payload: payload,
        payloadSuccess: tDomic
      });
    }
  },
  [ACTIONS.DO_CONSULTAR_DOMICILIO_SUCCESS]: (context, data) => {
    let respuesta = data.respuesta;
    const tDomic = data.payloadSuccess;
    if (data.status === "ERROR") {
      context.dispatch(ACTIONS.DO_CONSULTAR_DOMICILIO_ERROR, data.errorCode);
    } else {
      respuesta = mergeArrays(context.getters.getDomicilio(tDomic), respuesta);

      // Si una consulta viene sin datos, sobreescribe el valor de tDomic.
      // Restaurarlo.
      respuesta.tDomic = tDomic;
      respuesta.validarPreexistente = true;

      context.commit(MUTATIONS.ON_DOMICILIO, respuesta);
      context.commit(MUTATIONS.ON_IS_LOADING, false);
    }
  },
  [ACTIONS.DO_CONSULTAR_DOMICILIO_ERROR]: (context, error) => {
    Vue.$log.error(error);
    context.dispatch(ACTIONS.DO_MENSAJE, ERROR_CONEXION);
    context.commit(MUTATIONS.ON_IS_LOADING, false);
    return;
  },
  [ACTIONS.DO_DATOS_PERSONALES]: (context, { model, modelDomicilio }) => {
    context.commit(MUTATIONS.ON_IS_LOADING, true);
    /**
     * Validar domicilio
     */
    context.commit(MUTATIONS.ON_DATOS_PERSONALES, model);
    context.dispatch(ACTIONS.DO_VALIDAR_DOMICILIO, {
      modelDomicilio,
      nextStep: config.pasos[config.pasos.datosPersonales.pasoSiguiente].path
    });
  },
  [ACTIONS.DO_VALIDAR_DOMICILIO]: (
    context,
    { modelDomicilio, nextStep, tipoDomicilio }
  ) => {
    context.commit(MUTATIONS.ON_VALIDANDO_DOMICILIO, true);
    const payloadValidarDomicilio = JSON.parse(JSON.stringify(modelDomicilio));
    payloadValidarDomicilio.numClie = context.getters.getNumeroCliente();

    // Agrego 0 en CP
    payloadValidarDomicilio.codPost = payloadValidarDomicilio.codPost.padStart(
      5,
      "0"
    );

    // Formateo y valido payload
    payloadValidarDomicilio.desDomi = checkAndAddNoNumber(
      payloadValidarDomicilio.desDomi
    );

    // acción = 02 - PCG7 en modo validar
    payloadValidarDomicilio.accion = PCG7.ACCION.VALIDAR;

    // tipo domicilio?
    payloadValidarDomicilio.tDomic = tipoDomicilio ?? PCG7.TDOMIC.PARTICULAR;

    // M= modificar
    // A= alta
    let copiaDomicilio = context.getters.getDomicilio(
      payloadValidarDomicilio.tDomic
    );
    if (copiaDomicilio.preexistente) {
      payloadValidarDomicilio.opcion = PCG7.OPCION.MODIFICAR;
    } else {
      payloadValidarDomicilio.opcion = PCG7.OPCION.ALTA;
    }
    context.commit(MUTATIONS.ON_IS_LOADING, true);
    context.dispatch(ACTIONS.DO_REQUEST_API, {
      endPoint: END_POINTS.VALIDAR_DOMICILIO,
      doSuccess: ACTIONS.DO_VALIDAR_DOMICILIO_SUCCESS,
      doError: ACTIONS.DO_VALIDAR_DOMICILIO_ERROR,
      payload: payloadValidarDomicilio,
      payloadSuccess: { modelDomicilio, nextStep, tipoDomicilio }
    });
  },
  [ACTIONS.DO_VALIDAR_DOMICILIO_SUCCESS]: (context, data) => {
    context.commit(MUTATIONS.ON_IS_LOADING, false);

    if (data.status !== "OK") {
      return context.dispatch(ACTIONS.DO_VALIDAR_DOMICILIO_ERROR, data.error);
    }

    const respuesta = data.respuesta;
    let domicilio = cloneDeep(respuesta);

    // DOMICILIO VALIDADO PERO NO IDENTIFICADO POR MERLIN
    if (data.payloadSuccess.modelDomicilio.inusual) {
      return context.dispatch(ACTIONS.DO_GRABAR_DOMICILIO, {
        modelDomicilio: data.payloadSuccess.modelDomicilio,
        nextStep: data.payloadSuccess.nextStep,
        tipoDomicilio: data.payloadSuccess.tipoDomicilio
      });
    }

    // No es domicilio "inusual"
    if (
      domicilio.codPais &&
      domicilio.codPost &&
      domicilio.localid &&
      domicilio.desDomi &&
      !domicilio.desDomi.endsWith("S/N") &&
      ((domicilio.coorX &&
        domicilio.coorY &&
        domicilio.coorX !== "00.000000" &&
        domicilio.coorY !== "00.000000") ||
        domicilio.dudas.length > 0)
    ) {
      domicilio.inusual = false;
      context.commit(MUTATIONS.ON_DOMICILIO, domicilio);
      if (domicilio.dudas.length === 0) {
        // FIN -- PROCESAR
        return context.dispatch(ACTIONS.DO_PROCESAR_DOMICILIO, {
          modelDomicilio: context.getters.getDomicilio(
            data.payloadSuccess.tipoDomicilio
          ),
          nextStep: data.payloadSuccess.nextStep,
          tipoDomicilio: data.payloadSuccess.tipoDomicilio
        });
      }

      return;
    }

    // SI es domicilio "inusual"
    domicilio.inusual = true;
    return context.commit(MUTATIONS.ON_DOMICILIO, domicilio);
  },

  [ACTIONS.DO_VALIDAR_DOMICILIO_ERROR]: (context, error) => {
    Vue.$log.error(error);
    context.commit(MUTATIONS.ON_IS_LOADING, false);
    context.dispatch(ACTIONS.DO_MENSAJE, ERROR_CONEXION);
  },
  [ACTIONS.DO_PROCESAR_DOMICILIO]: (
    context,
    { modelDomicilio, nextStep, tipoDomicilio }
  ) => {
    context.commit(MUTATIONS.ON_IS_LOADING, true);
    modelDomicilio.accion = PCG7.ACCION.ACEPTAR;

    setModelDomicilioOption(context, modelDomicilio, tipoDomicilio);

    // Guardamos en state
    context.commit(MUTATIONS.ON_DOMICILIO, modelDomicilio);

    // Dispatch para procesar domicilio
    context.dispatch(ACTIONS.DO_REQUEST_API, {
      endPoint: END_POINTS.PROCESAR_DOMICILIO,
      doSuccess: ACTIONS.DO_PROCESAR_DOMICILIO_SUCCESS,
      doError: ACTIONS.DO_PROCESAR_DOMICILIO_ERROR,
      payload: modelDomicilio,
      payloadSuccess: { modelDomicilio, nextStep, tipoDomicilio }
    });
  },

  [ACTIONS.DO_PROCESAR_DOMICILIO_SUCCESS]: (context, data) => {
    context.commit(MUTATIONS.ON_IS_LOADING, false);
    const response = data;
    const errores = response.respuesta.errores;

    if (response.status === "OK") {
      return processHandleOkStatus(
        context,
        data.payloadSuccess.modelDomicilio,
        data.payloadSuccess.tipoDomicilio,
        response,
        errores,
        data.payloadSuccess.nextStep
      );
    }

    return processHandleErrorStatus(
      context,
      data.payloadSuccess.modelDomicilio,
      response
    );
  },

  [ACTIONS.DO_PROCESAR_DOMICILIO_ERROR]: (context, error) => {
    Vue.$log.error(error);
    context.commit(MUTATIONS.ON_IS_LOADING, false);
    context.dispatch(ACTIONS.DO_MENSAJE, ERROR_CONEXION);
  },

  [ACTIONS.DO_GRABAR_DOMICILIO]: (
    context,
    { modelDomicilio, nextStep, tipoDomicilio }
  ) => {
    context.commit(MUTATIONS.ON_IS_LOADING, true);

    setRehacerOption(modelDomicilio);

    // Guardamos en state
    context.commit(MUTATIONS.ON_DOMICILIO, modelDomicilio);

    // Dispatch para grabar domicilio
    context.dispatch(ACTIONS.DO_REQUEST_API, {
      endPoint: END_POINTS.GRABAR_DOMICILIO,
      doSuccess: ACTIONS.DO_GRABAR_DOMICILIO_SUCCESS,
      doError: ACTIONS.DO_GRABAR_DOMICILIO_ERROR,
      payload: modelDomicilio,
      payloadSuccess: { modelDomicilio, nextStep, tipoDomicilio }
    });
  },

  [ACTIONS.DO_GRABAR_DOMICILIO_SUCCESS]: (context, data) => {
    context.commit(MUTATIONS.ON_IS_LOADING, false);
    const response = data;
    const errores = response.respuesta.errores;

    if (response.status === "OK") {
      return guardarHandleOkStatus(
        context,
        data.payloadSuccess.modelDomicilio,
        data.payloadSuccess.tipoDomicilio,
        response,
        errores,
        data.payloadSuccess.nextStep
      );
    }

    // FIN
    context.dispatch(
      ACTIONS.DO_GRABAR_DOMICILIO_ERROR,
      "no se pudo procesar domicilio"
    );
  },

  [ACTIONS.DO_GRABAR_DOMICILIO_ERROR]: (context, error) => {
    Vue.$log.error(error);
    context.commit(MUTATIONS.ON_IS_LOADING, false);
    context.dispatch(ACTIONS.DO_MENSAJE, ERROR_CONEXION);
  },
  [ACTIONS.DO_FETCH_SUCURSALES]: (
    context,
    payload = { latitud: "-34.6037345", longitud: "-58.3837591" }
  ) => {
    context.commit(MUTATIONS.ON_IS_LOADING, true);

    om.sucursales(payload)
      .then(response => {
        context.commit(MUTATIONS.ON_SUCURSALES, response.data.data);
      })
      .catch(() => {
        setTimeout(() => {
          om.sucursales().then(response => {
            context.commit(MUTATIONS.ON_SUCURSALES, response.data.data);
          });
        }, 5000);
      });
  },
  [ACTIONS.DO_DATOS_LABORALES]: (context, payload) => {
    context.commit(MUTATIONS.ON_DATOS_LABORALES, payload);
  },
  [ACTIONS.DO_INFORMACION_ADICIONAL]: async (context, payload) => {
    context.commit(MUTATIONS.ON_INFORMACION_ADICIONAL, payload);
    // Verifico que no haya elegido PEP o SO
    if (
      get(payload, "pep", "0") === "1" ||
      get(payload, "sujetoObligado", "0") === "1" ||
      get(payload, "fatca", "0") === "1"
    ) {
      router.push({
        name: "continuaSucursal",
        params: { mensaje: "mensaje-1" }
      });
      return;
    }

    // Validación riesgo medio / alto
    if (["ofertaCajaAhorro", "ofertaCGU"].includes(_BBVA_MOTOR)) {
      const validRisk = await context.dispatch(ACTIONS.DO_VALIDAR_RIESGO);
      if (validRisk === false) {
        router.push({
          name: "continuaSucursal",
          params: { mensaje: "mensaje-3" }
        });
        return;
      }
      if (validRisk === null) {
        context.dispatch(ACTIONS.DO_MENSAJE, ERROR_TECNICO);
      }
    }

    // Envío al paso siguiente
    router.push(
      config.pasos[config.pasos.informacionAdicional.pasoSiguiente].path
    );
  },
  /**
   * Validar riesgo de cliente RA RM con PCGB
   *
   * @param {Vue Store Context} context
   * @returns Boolean | null
   */
  [ACTIONS.DO_VALIDAR_RIESGO]: async context => {
    // Validar riesgo de cliente con PCGB
    const clientId = context.getters.getNumeroCliente();

    context.commit(MUTATIONS.ON_IS_LOADING, true);
    try {
      const response = await om.validarRiesgoCliente({ clientId });
      const status = get(response, "data.status", "ERROR");
      const validRisk = get(response, "data.respuesta.validRisk", false);

      // Si status es OK y el riesgo es válido, retornamos true. De lo contrario, false.
      return status === "OK" && Boolean(validRisk);
    } catch (error) {
      Vue.$log.error("Error en validación de riesgo de cliente", error);
      // Si no podemos validar con la PCGB, por seguridad, no dejamos avanzar al cliente
      return null;
    } finally {
      context.commit(MUTATIONS.ON_IS_LOADING, false);
    }
  },
  [ACTIONS.DO_CLICK_CTA]: (context, payload) => {
    context.commit(MUTATIONS.ON_CLICK_CTA, payload);
  },
  [ACTIONS.DO_VERIDAS_EVENT]: (context, payload) => {
    context.commit(MUTATIONS.ON_VERIDAS_EVENT, payload);
  },
  [ACTIONS.DO_DIGITAL]: (context, payload) => {
    context.commit(MUTATIONS.ON_THANKS_VERIDAS, false);
    context.commit(MUTATIONS.ON_DIGITAL_PRESENCIAL, payload);
  },
  [ACTIONS.DO_PRESENCIAL]: (context, payload) => {
    context.commit(MUTATIONS.ON_THANKS_VERIDAS, false);
    context.commit(MUTATIONS.ON_DIGITAL_PRESENCIAL, payload);
    router.push(config.pasos.configuracion.path);
  },
  [ACTIONS.DO_DATA_AUTH_ASO](context, payload) {
    context.commit(MUTATIONS.ON_DATA_AUTH_ASO, payload);
  },
  [ACTIONS.DO_ENVIAR_EVENTO_DVS_FS]: async context => {
    try {
      const eventoPayload = {
        nroDoc: context.getters.getConsulta().numeroDoc,
        c: _BBVA_MOTOR + context.getters.getTCode(),
        tipoDocumento: context.getters.getConsulta().tipoDoc,
        deviceId: context.getters.getDeviceId(),
        deviceIdTimestamp: context.getters.getDeviceIdTimestamp(),
        numeroCliente: context.getters.getConsulta().numeroDoc,
        idBiometria: context.getters.getVeridasId()
      };
      await om.enviarEventoDvsFS(eventoPayload);
    } catch (error) {
      Vue.$log.error(error);
      context.commit(MUTATIONS.ON_ERROR, error);
    }
  },
  [ACTIONS.GET_REINTENTOS_BIO]: async context => {
    try {
      let numDoc = context.getters.getConsulta().numeroDoc;
      const response = await om.consultarReintentosBio(numDoc);
      //back responde OK, pero campo ERROR por dni vacio
      if (response.data.status === "ERROR") {
        router.push({
          name: "mensajeVeridas",
          params: { mje: "error-servidor" }
        });
        context.commit(MUTATIONS.ON_IS_LOADING, false);
        context.commit(MUTATIONS.ON_ERROR, "error-servidor");
        return false;
      }

      if (!response.data.respuesta) {
        // Agoto reintentos
        router.push({
          name: "mensajeVeridas",
          params: { mje: "error-veridas-ca" }
        });
        context.commit(MUTATIONS.ON_IS_LOADING, false);
        context.commit(MUTATIONS.ON_ERROR, "error-veridas-ca");
        return false;
      }
      return true;
    } catch (error) {
      Vue.$log.error(error);
      context.commit(MUTATIONS.ON_IS_LOADING, false);
      context.commit(MUTATIONS.ON_ERROR, error);
      router.push({
        name: "mensajeVeridas",
        params: { mje: "error-servidor" }
      });
    }
  },
  [ACTIONS.GET_VERIDAS_IFRAME]: async context => {
    try {
      const response = await withTsecAuth(ASO.getVeridasIframe);
      const iframeData = response.data.data;

      //responde OK, pero campos con error
      if (!("id" in iframeData) || !("urlXpressId" in iframeData)) {
        let message = "Error: La respuesta no contiene los datos del iframe.";
        Vue.$log.error(message, response);
        context.commit(MUTATIONS.ON_ERROR, message);
        router.push({
          name: "mensajeVeridas",
          params: { mje: "error-servicio-veridas" }
        });
        return;
      }

      context.commit(MUTATIONS.SET_DVS_IFRAME_DATA, iframeData);
      context.dispatch(ACTIONS.DO_ENVIAR_EVENTO_DVS_FS);
      return iframeData;
    } catch (error) {
      Vue.$log.error(error);
      context.commit(MUTATIONS.ON_IS_LOADING, false);
      context.commit(MUTATIONS.ON_ERROR, error);
      router.push({
        name: "mensajeVeridas",
        params: { mje: "error-servicio-aso" }
      });
    }
  },
  [ACTIONS.GET_VERIDAS_RESULT]: async (context, pendingCount = 0) => {
    try {
      const response = await withTsecAuth(
        ASO.getVeridasResult,
        context.getters.getVeridasId()
      );

      const responseData = response.data.data;

      if (responseData.result === "PENDING") {
        if (pendingCount >= 12) {
          const error = "Timeout veridas";
          Vue.$log.error(error);
          context.commit(MUTATIONS.ON_IS_LOADING, false);
          context.commit(MUTATIONS.ON_ERROR, error);
          context.commit(MUTATIONS.ON_ERROR_VERIDAS, "error-servicio-veridas");
          return;
        }
        return setTimeout(() => {
          context.dispatch(ACTIONS.GET_VERIDAS_RESULT, pendingCount + 1);
        }, 3000);
      }

      if (responseData.result === "OK" || responseData.result === "KO") {
        context.dispatch(ACTIONS.GET_RENAPER_VALIDATION);
      } else {
        let error = `Error getting Veridas Result: ${response}`;
        Vue.$log.error(error);
        context.commit(MUTATIONS.ON_IS_LOADING, false);
        context.commit(MUTATIONS.ON_ERROR, error);
        context.commit(MUTATIONS.ON_ERROR_VERIDAS, "error-servicio-veridas");
      }
      return;
    } catch (error) {
      Vue.$log.error(error);
      context.commit(MUTATIONS.ON_IS_LOADING, false);
      context.commit(MUTATIONS.ON_ERROR, error);
      context.commit(MUTATIONS.ON_ERROR_VERIDAS, "error-servicio-aso");
    }
  },
  [ACTIONS.GET_RENAPER_VALIDATION]: async (context, pendingCount = 0) => {
    try {
      /**
       * Llamar al ASO de Renaper y reintentar en caso de fallo
       * En ambientes previos puede fallar por error 400 en caso
       * de no contar con la info aún en base de datos
       * Se reintenta hasta 5 veces con un delay de 3 segundos
       */
      const [error, response] = await retry(
        () =>
          withTsecAuth(
            ASO.getRenaperValidation,
            context.getters.getVeridasId()
          ),
        3000,
        5
      );
      if (error) {
        Vue.$log.error(error);
        throw error;
      }

      const responseData = response.data.data;

      if (responseData.result === "PENDING") {
        if (pendingCount >= 12) {
          const error = "Timeout veridas";
          Vue.$log.error(error);
          context.commit(MUTATIONS.ON_IS_LOADING, false);
          context.commit(MUTATIONS.ON_ERROR, error);
          context.commit(MUTATIONS.ON_ERROR_VERIDAS, "error-servicio-veridas");
          return;
        }
        return setTimeout(() => {
          context.dispatch(ACTIONS.GET_RENAPER_VALIDATION, pendingCount + 1);
        }, 3000);
      }

      if (responseData.result === "FINISHED") {
        context.dispatch(ACTIONS.DO_ENVIAR_RESULTADOS_BIOMETRIA, responseData);
      } else {
        let message = "Error: falla resultados validacion.";
        Vue.$log.error(message, response);
        context.commit(MUTATIONS.ON_ERROR, message);
        context.commit(MUTATIONS.ON_ERROR_VERIDAS, "error-servicio-renaper");
        return;
      }
    } catch (error) {
      Vue.$log.error(error);
      context.commit(MUTATIONS.ON_IS_LOADING, false);
      context.commit(MUTATIONS.ON_ERROR, error);
      context.commit(MUTATIONS.ON_ERROR_VERIDAS, "error-servicio-aso");
    }
  },
  [ACTIONS.DO_ENVIAR_RESULTADOS_BIOMETRIA]: async (context, payload) => {
    try {
      const dvsStatusType = payload.message?.dvsStatusType;
      const renaper3Result = payload.message?.renaper3Desc?.validationResult;
      const renaper2Result = payload.message?.renaper2Desc?.validationResult;

      const dataOcr = payload.message?.dataOcrDesc || [];

      const getValue = (arr, key) =>
        arr.find(item => item.name === key)?.value || null;

      let dataOcrVeridas = {
        number: getValue(dataOcr, "DD_DocumentNumber_Out"),
        gender: getValue(dataOcr, "PD_Sex_Out"),
        names: getValue(dataOcr, "PD_Name_Out"),
        lastNames: getValue(dataOcr, "PD_LastName_Out"),
        birthDate: getValue(dataOcr, "PD_BirthDate_Out")
      };

      let body = {
        idBiometria: payload.id,
        valid: true,
        numTramite: context.getters.getOferta().nroDeTramite || "",
        personDataResponse: payload.message.renaper3Desc || "",
        ocrVeridas: dataOcrVeridas,
        circuito: _BBVA_MOTOR + context.getters.getTCode(),
        docNumEval: context.getters.getConsulta().numeroDoc,
        fechaNacEval: context.getters.getConsulta().fechaNacimiento,
        tipoDocumento: context.getters.getConsulta().tipoDoc,
        deviceId: context.getters.getDeviceId(),
        deviceIdTimestamp: context.getters.getDeviceIdTimestamp(),
        numeroCliente: context.getters.getConsulta().numeroDoc
      };

      const isValidVeridas =
        dvsStatusType === "OK" &&
        renaper3Result === "OK" &&
        renaper2Result === "OK";

      body.valid = isValidVeridas;

      /** Enviamos validación al back OM */
      const response = await om.enviarResultadosBiometria(body);
      const isValidOm = get(response, "data.respuesta.valid", false);
      const puedeReintentar = get(
        response,
        "data.respuesta.puedeReintentar",
        false
      );

      /** tenemos una biometría válida */
      if (isValidVeridas && isValidOm) {
        return router.replace(
          config.pasos[config.pasos.loadingVeridas.pasoSiguiente].path
        );
      }

      /** No tenemos una biometría válida, puede reintentar */
      if (puedeReintentar) {
        return context.commit(
          MUTATIONS.ON_ERROR_VERIDAS,
          "error-veridas-result"
        );
      }
      /** No puede reintentar, va a sucursal */
      context.commit(MUTATIONS.ON_ERROR_VERIDAS, "error-veridas-ca");
    } catch (error) {
      /** Ocurrió un error de servicio */
      Vue.$log.error(error);
      context.commit(MUTATIONS.ON_IS_LOADING, false);
      context.commit(MUTATIONS.ON_ERROR, error);
      context.commit(MUTATIONS.ON_ERROR_VERIDAS, "error-servicio-aso");
    }
  },
  [ACTIONS.DO_SAVE_IFRAME]: (context, payload) => {
    context.commit(MUTATIONS.ON_SAVE_IFRAME, payload);
  },
  [ACTIONS.DO_PRELOAD_SDK]: (context, payload) => {
    context.commit(MUTATIONS.ON_PRELOAD_SDK, payload);
  },
  [ACTIONS.DO_IS_VISIBLE_SDK]: (context, payload) => {
    context.commit(MUTATIONS.ON_IS_VISIBLE_SDK, payload);
  },
  [ACTIONS.DO_POST_VERIDAS_LOGIN]: (context, payload) => {
    agregarACola(() => {
      return new Promise((resolve, reject) => {
        context.commit(MUTATIONS.ON_RESULT_VERIDAS, { isValid: null });
        context.commit(MUTATIONS.ON_ERROR_VERIDAS, "");
        let circuito;
        switch (_BBVA_MOTOR) {
          case "ofertaCGU":
            circuito = "cgu";
            break;
          case "ofertaCajaAhorro":
            circuito = "caSuelta";
            break;
          case "ofertaEmprendedores":
            circuito = "caEmprendedores";
            break;
          default:
            circuito = "caNominas";
            break;
        }
        context.commit(MUTATIONS.ON_CONSULTA, { c: circuito });

        om.loginVeridas(
          context.getters.getConsulta(),
          context.getters.getDeviceId(),
          context.getters.getDeviceIdTimestamp(),
          context.getters.getNumeroCliente()
        )
          .then(resultLogin => {
            const { data } = resultLogin;

            if (data.status === "OK") {
              context.commit(MUTATIONS.ON_LOGIN, data.respuesta);
            } else if (data.status === "ERROR") {
              const errorType = data.respuesta.includes("intentos permitidos")
                ? ERROR_REINTENTOS_BIOMETRIA
                : ERROR_SERVICIO_VERIDAS;
              context.dispatch(ACTIONS.DO_IS_LOADING, false);
              context.commit(MUTATIONS.ON_ERROR_VERIDAS, errorType);
              reject();
              return;
            }

            // Enviar el frente del DNI
            context.dispatch(ACTIONS.DO_POST_FRONT_DNI, {
              resultLogin,
              payload
            });
            resolve();
          })
          .catch(error => {
            Vue.$log.info(error);
            context.commit(MUTATIONS.ON_FUNNEL_ERROR, error);
            context.commit(MUTATIONS.ON_ERROR_VERIDAS, ERROR_SERVICIO_VERIDAS);
            reject();
          });
      });
    });
  },
  [ACTIONS.DO_POST_FRONT_DNI]: async (
    context,
    { resultLogin, payload } = {}
  ) => {
    const errorVeridas = get(context, "state.errorVeridas", "");
    if (errorVeridas) return;
    agregarACola(() => {
      return new Promise((resolve, reject) => {
        //ATTACH OBVERSE
        const errorVeridas = get(context, "state.errorVeridas", "");
        if (errorVeridas) return;
        payload.append("key", resultLogin.data.respuesta.key);
        payload.append("c", get(context, "state.consulta.c", ""));
        context.dispatch(ACTIONS.DO_REQUEST_API, {
          endPoint: END_POINTS.ENVIO_FRENTE_DNI,
          doSuccess: ACTIONS.DO_ENVIO_FRENTE_DNI_SUCCESS,
          doError: ACTIONS.DO_POST_ERROR,
          payloadSuccess: { resolve, reject },
          payloadError: { reject },
          payload
        });
      });
    });
  },
  [ACTIONS.DO_ENVIO_FRENTE_DNI_SUCCESS]: (context, response) => {
    let respuesta = response.respuesta;
    if (response.status === "ERROR") {
      let strErrorToken = respuesta.includes("Access token expired");
      let strExpired = respuesta.includes("La verificaciÃ³n no estÃ¡ abierta");
      const errorType =
        strErrorToken || strExpired ? "error-tokenExpired" : "error-dni";
      context.dispatch(ACTIONS.DO_IS_LOADING, false);
      context.commit(MUTATIONS.ON_ERROR_VERIDAS, errorType);
      return response.payloadSuccess.reject();
    } else {
      return response.payloadSuccess.resolve();
    }
  },
  [ACTIONS.DO_POST_REVERSE_DNI]: (context, payload) => {
    const errorVeridas = get(context, "state.errorVeridas", "");
    if (errorVeridas) return;
    payload.set("key", context.getters.getKeyLoginVeridas());
    payload.append("c", get(context, "state.consulta.c", ""));
    agregarACola(() => {
      return new Promise((resolve, reject) => {
        context.dispatch(ACTIONS.DO_REQUEST_API, {
          endPoint: END_POINTS.ENVIO_REVERSO_DNI,
          doSuccess: ACTIONS.DO_POST_SUCCESS,
          doError: ACTIONS.DO_POST_ERROR,
          payloadSuccess: { resolve, reject },
          payloadError: { reject },
          payload
        });
      });
    });
  },

  [ACTIONS.DO_POST_SELFIES]: (context, { dataSelfie, dataSelfieAlive }) => {
    const errorVeridas = get(context, "state.errorVeridas", "");
    if (errorVeridas) return;
    dataSelfie.set("key", context.getters.getKeyLoginVeridas());
    dataSelfie.append("c", get(context, "state.consulta.c", ""));
    dataSelfieAlive.set("key", context.getters.getKeyLoginVeridas());
    dataSelfieAlive.append("c", get(context, "state.consulta.c", ""));

    // Envío selfie
    agregarACola(() => {
      return new Promise((resolve, reject) => {
        context.dispatch(ACTIONS.DO_REQUEST_API, {
          endPoint: END_POINTS.ENVIO_SELFIE,
          doSuccess: ACTIONS.DO_POST_SUCCESS,
          doError: ACTIONS.DO_POST_ERROR,
          payloadSuccess: { resolve, reject },
          payloadError: { reject },
          payload: dataSelfie
        });
      });
    });

    // Envío selfie alive
    agregarACola(() => {
      return new Promise((resolve, reject) => {
        context.dispatch(ACTIONS.DO_REQUEST_API, {
          endPoint: END_POINTS.ENVIO_SELFIE_ALIVE,
          doSuccess: ACTIONS.DO_POST_SUCCESS,
          doError: ACTIONS.DO_POST_ERROR,
          payloadSuccess: { resolve, reject },
          payloadError: { reject },
          payload: dataSelfieAlive
        });
      });
    });

    // Get result
    agregarACola(() => {
      return new Promise((resolve, reject) => {
        context.dispatch(ACTIONS.DO_GET_RESULT, { resolve, reject });
      });
    });
  },
  [ACTIONS.DO_POST_SUCCESS]: (context, response) => {
    if (response.status === "ERROR") {
      context.dispatch(ACTIONS.DO_IS_LOADING, false);
      context.commit(
        MUTATIONS.ON_ERROR_VERIDAS,
        identificarErrorFotoDNI(response.respuesta)
      );
      // Ocurrió un error, no llamar al getResult
      return response.payloadSuccess.reject();
    }

    return response.payloadSuccess.resolve();
  },
  [ACTIONS.DO_POST_ERROR]: (context, { error, payloadError }) => {
    context.commit(MUTATIONS.ON_FUNNEL_ERROR, error);
    context.commit(MUTATIONS.ON_RESULT_VERIDAS, { isValid: false });
    context.commit(MUTATIONS.ON_ERROR_VERIDAS, ERROR_SERVICIO_VERIDAS);
    return payloadError.reject();
  },

  [ACTIONS.DO_GET_RESULT]: async (context, { resolve, reject } = {}) => {
    try {
      const getResult = await om.getResultVeridas(
        context.getters.getKeyLoginVeridas(),
        context.getters.getOferta().nroDeTramite,
        context.getters.getConsulta(),
        context.getters.getDeviceId(),
        context.getters.getDeviceIdTimestamp(),
        context.getters.getNumeroCliente()
      );

      let camino = setearCaminosBiometria(
        get(getResult, "data.respuesta.valid", false),
        get(getResult, "data.respuesta.puedeReintentar", false),
        context.getters.getConsulta().circuito
      );

      if (
        get(getResult, "data.status", "ERROR") === "ERROR" ||
        get(getResult, "data.respuesta.message", "ok") === "error" ||
        !camino
      )
        camino = "ERROR";

      let strategy = caminosBiometria[camino];

      if (strategy) {
        if (camino === "ERROR") return strategy(context, getResult, resolve);
        return strategy(context, resolve);
      }
    } catch (error) {
      context.dispatch(ACTIONS.DO_IS_LOADING, false);
      context.commit(MUTATIONS.ON_FUNNEL_ERROR, error);
      context.commit(MUTATIONS.ON_RESULT_VERIDAS, {
        isValid: false
      });
      context.commit(MUTATIONS.ON_ERROR_VERIDAS, ERROR_SERVICIO_VERIDAS);
      return reject();
    }
  },
  [ACTIONS.DO_POST_SELFIE]: () => {},
  [ACTIONS.DO_POST_SELFIE_ALIVE]: () => {
    router.push(config.pasos[config.pasos.identidad.pasoSiguiente].path); //TODO
  },
  [ACTIONS.DO_CONFIGURACION]: (context, payload) => {
    if (get(context, "state.contratacionFinalizada", false)) {
      // EL usuario ya ha realizado la contratación.
      router.push(config.pasos[config.pasos.configuracion.pasoSiguiente].path);
      return false;
    }
    context.commit(MUTATIONS.ON_IS_LOADING, true);
    context.dispatch(ACTIONS.DO_REQUEST_API, {
      endPoint: END_POINTS.CONFIRMACION,
      doSuccess: ACTIONS.DO_CONFIRMACION_SUCCESS,
      doError: ACTIONS.DO_CONFIRMACION_ERROR,
      payload: context.getters.getConfirmacionDataVeridas(),
      payloadSuccess: payload
    });
  },
  [ACTIONS.DO_CONFIRMACION_SUCCESS]: (context, respuesta) => {
    let response = respuesta.respuesta;
    if (get(response, "errores[0]", []) === "Fallo engage") {
      // Contratación exitosa - aunque falla engage
      respuesta.payloadSuccess.numeroTramite = response.nroDeTramite;
      context.commit(MUTATIONS.ON_IS_LOADING, false);
      context.commit(MUTATIONS.ON_CONFIGURACION, respuesta.payloadSuccess);
      context.commit(MUTATIONS.ON_THANKS_VERIDAS, true);
      context.commit(MUTATIONS.ON_CONTRATACION, response);
      router.push(config.pasos[config.pasos.configuracion.pasoSiguiente].path);
      return false;
    }
    if (get(response, "errores[0]", "").includes("YQE0235")) {
      // Contratación para reintento con cron - job toma la tabla cobol - 24X7
      context.commit(MUTATIONS.ON_CONTRATACION, response);
      router.push(config.pasos[config.pasos.configuracion.pasoSiguiente].path);
      context.commit(MUTATIONS.ON_IS_LOADING, false);
      return false;
    }
    if (
      get(response, "errores[0]", "").includes("DEBE ACTUALIZAR DOMICILIO REAL")
    ) {
      //error domicilio no actualizado
      context.commit(MUTATIONS.ON_CONTRATACION, response);
      router.push({
        name: "mensaje",
        params: {
          mje: ERROR_REGISTRAR_DOMICILIO
        }
      });
      context.commit(MUTATIONS.ON_IS_LOADING, false);
      return false;
    }
    if (
      get(respuesta, "status", "ERROR") === "ERROR" ||
      get(response, "mensaje", "ok") === "error"
    ) {
      if (response.includes("403")) {
        router.push({
          name: "mensaje",
          params: {
            mje: RECHAZADO
          }
        });
        return;
      }
      context.commit(MUTATIONS.ON_IS_LOADING, false);
      context.commit(MUTATIONS.ON_FUNNEL_ERROR, response.data);
      router.push({
        name: "mensaje",
        params: {
          mje: getParamMensajeContratacion(get(response, "errores", []))
        }
      });
    } else {
      respuesta.payloadSuccess.numeroTramite = response.nroDeTramite;
      context.commit(MUTATIONS.ON_IS_LOADING, false);
      context.commit(MUTATIONS.ON_CONFIGURACION, respuesta.payloadSuccess);
      context.commit(MUTATIONS.ON_THANKS_VERIDAS, true);
      context.commit(MUTATIONS.ON_CONTRATACION, response);
      router.push(config.pasos[config.pasos.configuracion.pasoSiguiente].path);
    }
  },
  [ACTIONS.DO_CONFIRMACION_ERROR]: (context, error) => {
    context.commit(MUTATIONS.ON_IS_LOADING, false);
    context.commit(MUTATIONS.ON_FUNNEL_ERROR, error);
    context.dispatch(ACTIONS.DO_MENSAJE, ERROR_CONEXION);
  },
  [ACTIONS.DO_HUELLA_AVANZADA]: (context, payload) => {
    context.commit(MUTATIONS.ON_HUELLA_AVANZADA, payload);
  },
  [ACTIONS.DO_SEARCH_CONTRACT]: (context, payload) => {
    context.commit(MUTATIONS.ON_IS_LOADING, true);
    context.dispatch(ACTIONS.DO_REQUEST_API, {
      endPoint: END_POINTS.GET_CONTRACT,
      doSuccess: ACTIONS.DO_SEARCH_CONTRACT_SUCCESS,
      doError: ACTIONS.DO_SEARCH_CONTRACT_ERROR,
      payloadSuccess: payload,
      payload
    });
  },
  [ACTIONS.DO_SEARCH_CONTRACT_SUCCESS]: (context, response) => {
    context.commit(MUTATIONS.ON_IS_LOADING, true);
    Vue.$log.info(
      `Contratos encontrados mediante un nro de tramite ${response.payloadSuccess.numeroTramite}`,
      response
    );

    if (response.status !== "OK") {
      context.commit(MUTATIONS.ON_IS_LOADING, false);

      context.dispatch(ACTIONS.DO_MENSAJE, ERROR_CONEXION);
      return;
    }

    const contracts = response.respuesta.contratos;
    const listContract = [];
    const promisesContracts = contracts.map(contract => {
      listContract.push({
        urlPDFBase64: "",
        idForm: contract.idFormulario
      });

      return om.downloadContract({
        claseDocumental: contract.claseDocumental,
        idImagen: contract.idImagen
      });
    });

    Promise.all(promisesContracts)
      .then(responses => {
        responses.forEach((response, i) => {
          const binary = atob(response.data.respuesta.replace(/\s/g, ""));
          const len = binary.length;
          const buffer = new ArrayBuffer(len);
          const view = new Uint8Array(buffer);

          for (let j = 0; j < len; j++) {
            view[j] = binary.charCodeAt(j);
          }

          const blob = new Blob([view], { type: "application/pdf" });
          listContract[i].urlPDFBase64 = URL.createObjectURL(blob);
        });

        context.commit(MUTATIONS.ON_CONSULTA_CONTRATO, listContract);
        context.commit(MUTATIONS.ON_IS_LOADING, false);
      })
      .catch(error => {
        context.commit(MUTATIONS.ON_IS_LOADING, false);
        Vue.$log.info(error);
        context.commit(MUTATIONS.ON_FUNNEL_ERROR, error);
      });
  },
  [ACTIONS.DO_SEARCH_CONTRACT_ERROR]: (context, error) => {
    context.commit(MUTATIONS.ON_FUNNEL_ERROR, error);
    context.commit(MUTATIONS.ON_IS_LOADING, false);
    context.dispatch(ACTIONS.DO_MENSAJE, ERROR_CONEXION);
  },
  [ACTIONS.DO_CONTRATO_PENDING_SIGNATURE]: (context, payload) => {
    context.commit(MUTATIONS.ON_CONTRATO, payload);
  },
  [ACTIONS.DO_CONTRATO]: (context, payload) => {
    if (get(context, "state.contratosFirmados", false)) {
      // EL usuario ya ha realizado la contratación.
      router.push({
        name: "mensaje",
        params: {
          mje: YA_CONTRATO
        }
      });
      return false;
    }
    let randomKey = context.getters.getRandomKey();
    let contrats = context.getters.getContractsPdf();
    let signContracts = {
      contratosFirmados: {},
      numeroTramite: context.getters.getNumeroTramite(),
      randomKey: randomKey
    };

    for (const contract of contrats) {
      let key = contract.idForm;
      signContracts.contratosFirmados[key] = signTime(key)[key];
    }

    function signTime(key) {
      let d = new Date(),
        dformat =
          [
            d.getFullYear(),
            evalNumber(d.getMonth() + 1),
            evalNumber(d.getDate())
          ].join("-") +
          "-" +
          [
            evalNumber(d.getHours()),
            evalNumber(d.getMinutes()),
            evalNumber(d.getSeconds()),
            d.getMilliseconds()
          ].join(".");
      let obj = {};
      obj[key] = dformat;
      return obj;
    }

    function evalNumber(number) {
      if (number < 10) {
        number = "0" + number.toString();
      }
      return number;
    }
    context.commit(MUTATIONS.ON_IS_LOADING, true);
    context.dispatch(ACTIONS.DO_REQUEST_API, {
      endPoint: END_POINTS.SIGN_CONTRACTS,
      doSuccess: ACTIONS.DO_CONTRATO_SUCCESS,
      doError: ACTIONS.DO_CONTRATO_ERROR,
      payloadSuccess: payload,
      payload: signContracts
    });
  },
  [ACTIONS.DO_CONTRATO_SUCCESS]: (context, response) => {
    if (response.status === "OK") {
      context.commit(MUTATIONS.ON_IS_LOADING, false);
      context.commit(MUTATIONS.ON_CONTRATO, response.payloadSuccess);
      context.commit(MUTATIONS.ON_FIRMA_CONTRATOS);

      router.push(config.pasos[config.pasos.contrato.pasoSiguiente].path);
    } else {
      context.commit(MUTATIONS.ON_IS_LOADING, false);
      context.dispatch(ACTIONS.DO_MENSAJE, ERROR_CONEXION);
    }
  },
  [ACTIONS.DO_CONTRATO_ERROR]: (context, error) => {
    context.commit(MUTATIONS.ON_IS_LOADING, false);
    Vue.$log.info(error);
    context.commit(MUTATIONS.ON_FUNNEL_ERROR, error);
    context.dispatch(ACTIONS.DO_MENSAJE, ERROR_CONEXION);
  },
  [ACTIONS.DO_NORMALIZAR_CELULAR]: (context, payload) => {
    if (payload.status !== "CO") {
      context.commit(MUTATIONS.ON_NORMALIZAR_CELULAR, { valido: false });
    } else {
      const celularNormalizado = {
        area: Number(payload.ddn).toString(),
        nro: payload.phoneNumber,
        caracteristica: payload.characteristic,
        valido: true
      };
      context.commit(MUTATIONS.ON_NORMALIZAR_CELULAR, celularNormalizado);
    }
  },
  [ACTIONS.DO_ENVIO_CELULAR]: (context, payload) => {
    context.commit(MUTATIONS.ON_IS_LOADING, true);
    context.dispatch(ACTIONS.DO_REQUEST_API, {
      endPoint: END_POINTS.GENERAR_OTP,
      doSuccess: ACTIONS.DO_ENVIO_CELULAR_SUCCESS,
      doError: ACTIONS.DO_ENVIO_CELULAR_ERROR,
      payloadSuccess: payload,
      payload
    });
  },
  [ACTIONS.DO_ENVIO_CELULAR_SUCCESS]: (context, payload) => {
    context.commit(MUTATIONS.ON_IS_LOADING, false);
    if (payload.status === "OK") {
      let bodyData = {
        otp: payload.respuesta.otp,
        deviceUdid: payload.payloadSuccess.deviceUdid
      };
      context.commit(MUTATIONS.ON_OTP_ONE, bodyData);
      context.dispatch(ACTIONS.DO_NOTIFICATION_TOAST, {
        type: "success",
        message: "Te enviamos un SMS a tu celular."
      });
    } else {
      context.commit(MUTATIONS.ON_IS_LOADING, false);
      context.dispatch(ACTIONS.DO_MENSAJE, ERROR_CONEXION);
    }
  },
  [ACTIONS.DO_ENVIO_CELULAR_ERROR]: (context, error) => {
    context.commit(MUTATIONS.ON_IS_LOADING, false);
    context.commit(MUTATIONS.ON_FUNNEL_ERROR, error);
    context.dispatch(ACTIONS.DO_MENSAJE, ERROR_CONEXION);
  },
  [ACTIONS.DO_CELULAR]: (context, payload) => {
    let deviceUdid = context.getters.getDeviceUdid();
    context.commit(MUTATIONS.ON_IS_LOADING, true);
    let body = {
      otp: payload.otp,
      deviceUdid: deviceUdid
    };
    context.dispatch(ACTIONS.DO_REQUEST_API, {
      endPoint: END_POINTS.VALIDAR_OTP,
      doSuccess: ACTIONS.DO_CELULAR_SUCCESS,
      doError: ACTIONS.DO_CELULAR_ERROR,
      payloadSuccess: payload,
      payload: body
    });
  },
  [ACTIONS.DO_CELULAR_SUCCESS]: (context, payload) => {
    const isError =
      get(payload, "status", "ERROR") === "ERROR" ||
      get(payload, "respuesta.mensaje", "ok") === "error";
    context.commit(MUTATIONS.ON_IS_LOADING, false);
    if (isError) {
      context.commit(MUTATIONS.ON_OTP_ERROR);
      context.commit(MUTATIONS.ON_FUNNEL_ERROR, payload);
      return;
    }
    context.commit(MUTATIONS.ON_CELULAR, {
      ...payload.payloadSuccess,
      otpValid: Boolean(payload.respuesta.valid)
    });

    if (payload.respuesta.valid) {
      context.dispatch(ACTIONS.DO_NOTIFICATION_TOAST, {
        type: "success",
        message: "Tu celular se validó exitosamente."
      });
      router.push(config.pasos[config.pasos.celular.pasoSiguiente].path);
    }
  },
  [ACTIONS.DO_CELULAR_ERROR]: (context, error) => {
    context.commit(MUTATIONS.ON_IS_LOADING, false);
    context.commit(MUTATIONS.ON_FUNNEL_ERROR, error);
    context.commit(MUTATIONS.ON_OTP_ERROR);
  },
  [ACTIONS.DO_USUARIO_CLAVE]: (context, payload) => {
    context.commit(MUTATIONS.ON_IS_LOADING, true);
    context.commit(MUTATIONS.ON_USUARIO_CLAVE, payload);
    let randomKey = context.getters.getRandomKey();
    payload.randomKey = randomKey;
    context.dispatch(ACTIONS.DO_REQUEST_API, {
      endPoint: END_POINTS.CREAR_USUARIO,
      doSuccess: ACTIONS.DO_USUARIO_CLAVE_SUCCESS,
      doError: ACTIONS.DO_USUARIO_CLAVE_ERROR,
      payload
    });
  },
  [ACTIONS.DO_USUARIO_CLAVE_SUCCESS]: (context, payload) => {
    Vue.$log.info("Se ha creado el usuario correctamente", payload);
    router.push(config.pasos[config.pasos.usuarioClave.pasoSiguiente].path);
    context.commit(MUTATIONS.ON_IS_LOADING, false);
  },
  [ACTIONS.DO_USUARIO_CLAVE_ERROR]: (context, error) => {
    context.commit(MUTATIONS.ON_IS_LOADING, false);
    context.commit(MUTATIONS.ON_FUNNEL_ERROR, error);
    context.dispatch(ACTIONS.DO_MENSAJE, ERROR_CONEXION);
  }
};
